import { CLPBilling } from "./clpBilling.model";
import { CLPUserPref } from "./clpUserPref.model";
import { ClpCompany } from "./company.model";
import { eCLPCompanyStatus, eCLPPricingContract, eCLPVARContractType, eCLPVARPaymentSchedule, eCLPVARStatus } from "./enum.model";
import { IntDropDownItem, SimpleResponse } from "./genericResponse.model";
import { LogType } from "./logType.model";
import { keyValue } from "./search.model";

export interface AccountInformation {
  clpCompanyID: number;
  companyName: string;
  add1: string;
  add2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  companyURL: string;
  logoURL: string;
  status: string;

  cLPUserID: number;
  billingName: string;
  comments: string;
  useCC: boolean;
  pONumber: string;
  cCName: string;
  cCType: number;
  cCNumber: string;
  cCExMonth: number;
  cCExYear: number;
  cCCid: string;
  feeSetup: number;
  feeCompany: number;
  feeUser: number;
  discountUser: number;
  feeMonthlyRider: number;
  feeSupportHour: number;
  feeAdditionalContacts: number;
  accountBalance: number;
  supportCredit: number;
  additionalContactsIncrements: number;
  cycleDay: number;
  contract: number;
  dtContractExpire: Date;
  dtNextBillDate: Date;
  dtPromoExpire: Date;
  isOnPromo: boolean;
  cLPVARID: number;
  dtCreated: number;
  tmpCCName: string;
  tmpCCType: number;
  tmpCCNumber: string;
  tmpCCExMonth: number;
  tmpCCExYear: number;
  tmpCCCid: string;
  tmpAdd1: string;
  tmpAdd2: string;
  tmpCity: string
  tmpState: string;
  tmpZip: string;
  tmpCountry: string;
  encCCNumber: number;
  tmpEncCCNumber: number;
  monthlyFee: number;
  userCount: number;



  isSFAIncluded: boolean;
  isMobileIncluded: boolean;
  isHTMLEmailIncluded: boolean;
  isOutlookIncluded: boolean;
  isProjectModuleInstalled: boolean
  isMultipleFromAddresses: boolean;
  isBrandingIncluded: boolean;
  enableMoreFields: boolean;
  enableCLPSS: boolean;
  isEmailValidation: boolean;
  blnMailingFromType: boolean;
  blnEnableiPhone: boolean;
  blnLogSkypeCalls: boolean;
  useCompanyModule: boolean;
  maxEblast: number;
  maxContacts: number;
  isSOCRM: boolean;
  isSODigital: boolean;
  isSOProServ: boolean;


  //add1: string;
  //add2: string;
  //city: string;
  //state: string;
  //zip: string;
  //Country: string;
}

export interface AccountInformationRespone {
  accountInformation: AccountInformation;
}

export interface AdminSOAAccounts {
  clpCompanyID: number;
  companyName: string;
  status: number;
  StatusDisplay: string;
  tickets: number;
  clpRole: number;
}

export interface AdminSOAAccountListResponse extends SimpleResponse {
  adminSOAAccountList: AdminSOAAccounts[];
}

export interface CLPUserPrefResponse extends SimpleResponse {
  cLPUserPrefList: CLPUserPrefList[];
}

export interface CLPUserPrefList {
   userCode: string;
   userDisplay: string;
   txtMsgLongCode: string;
   isCallForwardingLine: boolean;
   callForwardAPID: number;
   isClickToCallLine: boolean;
   isVCREnabled: boolean;
   isVoiceDropLine: boolean;
   isKMLEnabled: boolean;
   isSOLeadGen: boolean;
   isSingleSignOn: boolean;
   isVIPEnabled: boolean;
   isSGVIPEnabled: boolean;
}

export interface CLPLogParameters {
  supportLogin: number;
  clpCompanyId: number;
  clpUserId: number;
  clpLogTypeID: number;
  endDate: string;
  startDate: string;
}

export interface CLPLogListResponse extends SimpleResponse {
  activityLogs: CLPLog[];
}

export interface ActivityLogFilterResponse extends SimpleResponse {
  userList: IntDropDownItem[];
  clpLogTypes: LogType[];
}

export interface CLPLog {
   cLPLogID: number;
   cLPCompanyID: number;
   cLPUserID: number;
   cLPLogTypeID: number;
   cLPSSID: number;
   isSupportLogin: boolean;
   note: string;
   dtCreated: Date;
   userName: string;
   clpLogType: string;
}

export interface APIKeyLoadResponse {
  apiKey: APIKey
  webformList: WebFormList
}

export interface APIKey {
  cLPCompanyID: number;
  webFormId: number;
  clientId: string;
  clientSecret: string;
  redirectURI: string;
  dtCreated: Date;
  dtModified: Date;
}

export interface WebFormList {
  webFormID: number;
  formName: string;
}

export interface GenerateKeyResponse extends SimpleResponse{
  clientIDKey: string;
  clientSecretKey: string;
}


export interface UsersListsResponse {
  iPhoneEnableUsers: CLPUserDetails[];
  iPhoneDisableUsers: CLPUserDetails[];
}
export interface CLPUserDetails {
  fullname: string;
  clpUserId: number;
  enableiPhone: boolean;
}

export interface CompanyModuleResponse extends SimpleResponse {
  companyModule: CompanyModule;
}

export interface CompanyModule {
  cnt: number;
  resultID: number;
}

export interface AccountInformationLoadResponse extends SimpleResponse {
  isAccountCancellation: boolean;
  userList: IntDropDownItem[];
  clpVarList: CLPVar[];
  accountInformation: AccountInformation;
}

export interface CLPVar {
  clpVarId: number;
  clpCompanyId: number;
  clpUserId: number;
  varName: string;
  supportEmail: string;
  dtContractExpiration: string;
  contractType: eCLPVARContractType;
  paymentSchedule: eCLPVARPaymentSchedule;
  notes: string;
  status: eCLPVARStatus;
  dtModified: string;
  dtCreated: string;
}

export interface AccountInfoSaveObj {
  clpCompanyId: number;
  clpUserId: number;
  isInvoiceModule: boolean;
  ddCLPStatus: eCLPCompanyStatus;
  ddCLPVarSelected: eCLPVARStatus;
  ddBillingUser: number;
  ddContractSelected: eCLPPricingContract;
  nextBillingDate: string;
  contractDate: string;
  promoExpireDate: string;
  showAdminSettings: boolean;
  accountInfoObj: AccountInformation;
}

export interface CLPUserPreferenceResponse extends SimpleResponse {
  cLPUserPrefList: CLPUserPref[];
}
